import { render, staticRenderFns } from "./ImportsTableRow.vue?vue&type=template&id=f64a077e"
import script from "./ImportsTableRow.vue?vue&type=script&lang=ts"
export * from "./ImportsTableRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports